<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: "modalRescheduleSend",
  components: {
    DatePicker,
  },
  props: {
    proof: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      appEventId: 0,
      scheduledSendAt: null,
      scheduledDate: null,
      scheduledTime: null,
      scheduledSendTimeZone: "",
      working: false,
    };
  },
  mounted() {
    this.$root.$on('proof::reschedule-send', (event) => {
      this.openWithEvent(event);
    });
  },
  beforeDestroy() {
    this.$root.$off('proof::reschedule-send');
  },
  watch: {
    scheduledDate() { this.combineDateTime(); },
    scheduledTime() { this.combineDateTime(); },
  },
  methods: {
    combineDateTime() {
      if (this.scheduledDate && this.scheduledTime) {
        const d = new Date(this.scheduledDate);
        const t = new Date(this.scheduledTime);
        this.scheduledSendAt = new Date(d.getFullYear(), d.getMonth(), d.getDate(), t.getHours(), t.getMinutes(), 0);
      } else {
        this.scheduledSendAt = null;
      }
    },
    openWithEvent(event) {
      this.appEventId = event.id;
      this.scheduledSendTimeZone = _.get(this, '$A.Auth.userSettings.reminderTimeZone', '') ||
          this.$A.TimeZoneService.GetTimeZoneFromCurrentBrowserZone().name;

      // Parse the existing queued action date for display
      const queuedAt = _.get(event, 'appEventObject.queuedActionAt', null);
      if (queuedAt) {
        const existing = new Date(queuedAt);
        this.scheduledDate = new Date(existing.getFullYear(), existing.getMonth(), existing.getDate());
        this.scheduledTime = new Date(0, 0, 0, existing.getHours(), existing.getMinutes());
        this.scheduledSendAt = existing;
      } else {
        this.scheduledDate = null;
        this.scheduledTime = null;
        this.scheduledSendAt = null;
      }

      this.$bvModal.show("RescheduleSend");
    },
    async reschedule() {
      if (!this.scheduledSendAt) {
        this.$A.AlertUser("Please select a date and time", "warning", 5000);
        return;
      }
      if (this.scheduledSendAt < new Date()) {
        this.$A.AlertUser("Scheduled time must be in the future", "warning", 5000);
        return;
      }
      this.working = true;
      await this.$A.ProofService.RescheduleScheduledSend(
          this.proof.id,
          this.appEventId,
          this.scheduledSendAt,
          this.scheduledSendTimeZone
      );
      this.working = false;
      this.$bvModal.hide("RescheduleSend");
      this.$root.$emit("proof::refresh", {});
    },
    async sendNow() {
      this.working = true;
      await this.$A.ProofService.SendScheduledProofNow(
          this.proof.id,
          this.appEventId
      );
      this.working = false;
      this.$bvModal.hide("RescheduleSend");
      this.$root.$emit("proof::refresh", {});
    },
  },
};
</script>

<template>
  <b-modal id="RescheduleSend" size="lg" :modal-class="'reschedule-modal'">
    <template v-slot:modal-header>
      <alertHeader/>
      <div class="w-100">
        <h4 class="header-text">Reschedule Proof Send</h4>
        <div class="sub-text">
          Choose a new date and time, or send the proof immediately.
        </div>
      </div>
    </template>

    <form role="form" class="modal-form">
      <div class="schedule-section">
        <div class="schedule-row">
          <div class="schedule-field">
            <label class="label-text">Date</label>
            <date-picker
                v-model="scheduledDate"
                type="date"
                format="MM/DD/YYYY"
                placeholder="Select date"
                class="w-100"
                :append-to-body="true"
                :popup-style="{ zIndex: 1100 }"
                :disabled-date="(date) => date < new Date(new Date().setHours(0,0,0,0))"
            />
          </div>
          <div class="schedule-field">
            <label class="label-text">Time</label>
            <date-picker
                v-model="scheduledTime"
                type="time"
                format="hh:mm A"
                :use12h="true"
                placeholder="Select time"
                class="w-100"
                :append-to-body="true"
                :popup-style="{ zIndex: 1100 }"
                :minute-step="5"
            />
          </div>
        </div>
        <div class="mt-3">
          <label class="label-text">Timezone</label>
          <select v-model="scheduledSendTimeZone" class="form-control modal-input">
            <option v-for="tz in $A.TimeZoneService.GetAllTimeZoneNames()" :key="tz">
              {{ tz }}
            </option>
          </select>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer="{ cancel }">
      <div class="w-100 col-md-12 d-flex justify-content-md-end px-0 footer-buttons">
        <b-button
            class="button gray-btn"
            @click="cancel()"
        >Cancel
        </b-button>
        <b-button
            :disabled="working"
            class="button send-now-btn"
            @click="sendNow()"
        >Send Now
        </b-button>
        <b-button
            :disabled="working"
            class="button green-btn"
            @click="reschedule()"
        >Reschedule
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped>
.header-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #252526;
  margin-bottom: 12px;
}

.sub-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #575759;
}

.label-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #707073;
  margin-bottom: 4px;
}

.modal-input {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 13px;
  background: white;
  border: 1px solid #B5B5B8;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
  height: 40px;
}

.modal-form {
  padding: 0px 24px 0px 24px !important;
}

.gray-btn {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #444444;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 17px !important;
  height: 38px;
  filter: drop-shadow(0px 1px 2px rgba(8, 11, 13, 0.05));
  border-radius: 6px;
}

.send-now-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 17px !important;
  height: 38px;
  background: #fff;
  border: 1px solid #019256;
  color: #019256;
  box-shadow: 0px 1px 2px rgb(8 11 13 / 5%);
  border-radius: 6px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
}

.send-now-btn:hover {
  background: #019256;
  color: #fff;
}

.green-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 17px !important;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgb(8 11 13 / 5%);
  border-radius: 6px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
}

.gray-btn:hover {
  background-color: lightgray;
  border: lightgray solid 1px;
}

.schedule-section {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 16px;
}

.schedule-row {
  display: flex;
  gap: 12px;
}

.schedule-field {
  flex: 1;
  min-width: 0;
}

.schedule-field /deep/ .mx-datepicker {
  width: 100% !important;
}

.schedule-field /deep/ .mx-input {
  height: 40px;
  border: 1px solid #B5B5B8;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  font-family: 'Open Sans';
  font-size: 13px;
  color: #252526;
}

.schedule-field /deep/ .mx-input:hover,
.schedule-field /deep/ .mx-input:focus {
  border-color: #019256;
}


@media screen and (max-width: 1180px) {
  .footer-buttons {
    justify-content: end;
    margin-bottom: 0px !important;
    padding: 0px;
    align-items: center;
    margin-top: 12px !important;
  }
}
</style>

<style>
/* Unscoped: these elements are appended to body, outside the component scope */
.mx-datepicker-popup {
  z-index: 20010 !important;
}

#RescheduleSend___BV_modal_outer_ {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20001 !important;
}

/* Ensure schedule section doesn't clip the datepicker */
#RescheduleSend .schedule-section {
  overflow: visible !important;
}

#RescheduleSend .modal-body {
  overflow: visible !important;
}

#RescheduleSend .modal-content {
  overflow: visible !important;
}

#RescheduleSend .modal-dialog {
  overflow: visible !important;
}
</style>
